import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/TermsAndConditions.css";
import InnerPageHeader from "./InnerPageHeader";
import HomepageButton from "./HomepageButton";
import Footer from "./Footer";

export default function TermsAndConditions() {
  const { t } = useTranslation("terms");
  const { t: tc } = useTranslation("common");

  const sections = t("sections", { returnObjects: true });

  return (
    <>
      <InnerPageHeader title={t("title")} />

      <div className="terms-body">
        <div className="terms-content">
          {sections.map((section, index) => (
            <div key={index} className="terms-section">
              <h2>{section.heading}</h2>
              <p>{section.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="terms-back">
        <HomepageButton label={tc("back")} href="/#homepage" />
      </div>

      <Footer />
    </>
  );
}
